import { render } from "./third-party-loader.vue?vue&type=template&id=3281c342"
import script from "./third-party-loader.vue?vue&type=script&lang=js"
export * from "./third-party-loader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__